import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";
import { useIsMobile } from "routes/wps/attendees/hooks/useIsMobile";
import { ITopBanner } from "interfaces";

interface PropType {
  menuOpen: boolean;
  banners?: ITopBanner[];
}

const WPSTopBanner = (props: PropType) => {
  const { menuOpen, banners = [] } = props;

  const isMobile = useIsMobile(1024);

  if (banners?.length === 0) return null;

  return (
    <div
      className={`w-full transition-all duration-300
                  ${menuOpen ? "lg:pl-72" : "lg:pl-0"}
                `}
    >
      <div className="relative flex items-center">
        {/* Left Button */}
        {!isMobile && (
          <div className="custom-prev-button size-[24px] rounded-full bg-white absolute left-[10px] z-[5] cursor-pointer flex items-center justify-center">
            <ChevronLeftIcon className="size-[16px]" />
          </div>
        )}

        {/* Right Button */}
        {!isMobile && (
          <div className="custom-next-button size-[24px] rounded-full bg-white absolute right-[10px] z-[5] cursor-pointer flex items-center justify-center">
            <ChevronRightIcon className="size-[16px]" />
          </div>
        )}

        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".custom-next-button",
            prevEl: ".custom-prev-button",
          }}
          loop={true}
          modules={[Autoplay, Pagination, Navigation]}
        >
          {banners?.map((item, index: number) => {
            return (
              <SwiperSlide key={`top_banner_item_${index}`}>
                {item?.open_url && item?.open_url !== "" ? (
                  <a
                    className="w-full cursor-pointer"
                    href={item?.open_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      loading="lazy"
                      src={item?.banner}
                      className={`w-full`}
                      alt="slide-top-banner"
                    />
                  </a>
                ) : (
                  <img
                    loading="lazy"
                    src={item?.banner}
                    className={`w-full`}
                    alt="slide-top-banner"
                  />
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default WPSTopBanner;
